// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import { get } from 'utilities/objects'

// Redux:
import * as reduxAccount from 'actions/account'
import * as reduxPage from 'actions/page'

class PageData extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		if ( this.props.match ) {
			this.refresh()
		}

		zenscroll.setup( 400, siteData.scroll_offset )
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		const { history, match, location } = this.props

		const locationHash = history.location.hash.slice( 1 )
		const path = location.pathname
		const pathSegments = path.split( '/' ).filter( Boolean )
		const prevPath = prevProps.location.pathname
		const prevPathSegments = prevPath.split( '/' ).filter( Boolean )

		const thisPageSlug = pathSegments[0]
		const lastPageSlug = prevPathSegments[0]

		let thisPageNumber, lastPageNumber
		let thisPageNumberMatch = path.match( /\/page\/(\d*)/ )
		let lastPageNumberMatch = prevPath.match( /\/page\/(\d*)/ )

		if ( thisPageNumberMatch ) {
			thisPageNumber = thisPageNumberMatch[1]
		}

		if ( lastPageNumberMatch ) {
			lastPageNumber = lastPageNumberMatch[1]
		}

		const thisSubpageSlug = pathSegments[1]
		const lastSubpageSlug = prevPathSegments[1]

		let canScrollToTop = true,
			scrollToElement = false,
			disablePageTransition = false

		// Don't scroll to the top when jumping to an anchor:
		if ( locationHash && match.path == prevProps.match.path ) {
			canScrollToTop = false
		}

		if ( 'blog' == thisPageSlug ) {
			scrollToElement = document.querySelector( '.js-scroll-position' )
		}

		if ( canScrollToTop ) {
			if ( scrollToElement ) {
				setTimeout( () => {
					zenscroll.to( scrollToElement )
				}, 200 )
			} else {
				zenscroll.toY( 0 )
			}
		}

		if ( disablePageTransition ) {
			document.documentElement.classList.add( 'disable-transition-leaving' )
		} else {
			document.documentElement.classList.remove( 'disable-transition-leaving' )
		}

		if (
			thisPageSlug != lastPageSlug ||
			thisSubpageSlug != lastSubpageSlug ||
			thisPageNumber != lastPageNumber
			) {
			this.refresh()
		}
	}

	refresh = () => {
		const { history, dispatch, match, location, page } = this.props
		const locationHash = history.location.hash.slice( 1 )
		const title = get( [ 'page', 'title', 'raw' ] )( page, false )

		const path = location.pathname
		const pathSegments = path.split( '/' ).filter( Boolean )
		const thisPageSlug = pathSegments[0]
		const thisSubpageSlug = pathSegments[1]

		if ( '/' == path ) {
			dispatch( reduxPage.getPageData( 'home', 'page' ) )
		} else if ( path.indexOf( '/post/' ) > -1 ) {
			dispatch( reduxPage.getPageData( thisSubpageSlug, 'post' ) )
		} else if ( thisPageSlug ) {
			dispatch( reduxPage.getPageData( thisPageSlug, 'page' ) )
		}

		if ( path.indexOf( '/blog' ) > -1 ) {
			let pageNumber
			let pageNumberMatch = path.match( /\/page\/(\d*)/ )

			if ( pageNumberMatch ) {
				pageNumber = pageNumberMatch[1]
			}

			if ( pageNumber ) {
				dispatch( reduxPage.getPageData( 'posts', 'posts', pageNumber ) )
			} else {
				dispatch( reduxPage.getPageData( 'posts', 'posts' ) )
			}
		}

		if ( title ) {
			document.title = title
		} else {
			document.title = siteData.site_name
		}
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default withRouter(
	connect( mapStateToProps )( PageData )
)



// WEBPACK FOOTER //
// ./containers/PageData.jsx